var map = {
	"./ods-1.jpg": "./src/assets/imagenes/ods/ods-1.jpg",
	"./ods-10.jpg": "./src/assets/imagenes/ods/ods-10.jpg",
	"./ods-11.jpg": "./src/assets/imagenes/ods/ods-11.jpg",
	"./ods-12.jpg": "./src/assets/imagenes/ods/ods-12.jpg",
	"./ods-13.jpg": "./src/assets/imagenes/ods/ods-13.jpg",
	"./ods-14.jpg": "./src/assets/imagenes/ods/ods-14.jpg",
	"./ods-15.jpg": "./src/assets/imagenes/ods/ods-15.jpg",
	"./ods-16.jpg": "./src/assets/imagenes/ods/ods-16.jpg",
	"./ods-17.jpg": "./src/assets/imagenes/ods/ods-17.jpg",
	"./ods-2.jpg": "./src/assets/imagenes/ods/ods-2.jpg",
	"./ods-3.jpg": "./src/assets/imagenes/ods/ods-3.jpg",
	"./ods-4.jpg": "./src/assets/imagenes/ods/ods-4.jpg",
	"./ods-5.jpg": "./src/assets/imagenes/ods/ods-5.jpg",
	"./ods-6.jpg": "./src/assets/imagenes/ods/ods-6.jpg",
	"./ods-7.jpg": "./src/assets/imagenes/ods/ods-7.jpg",
	"./ods-8.jpg": "./src/assets/imagenes/ods/ods-8.jpg",
	"./ods-9.jpg": "./src/assets/imagenes/ods/ods-9.jpg",
	"./ods.jpg": "./src/assets/imagenes/ods/ods.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imagenes/ods sync recursive ^\\.\\/.*$";